const SET_LIST = (state, payload) => {
  state.list = payload
}

export default {
  SET_LIST
}



// WEBPACK FOOTER //
// ./src/features/tenant_representatives/store/mutations.js